import classNames from "classnames";
import { FunctionComponent, memo } from "react";

import "./box-content.scss";
import { IProps } from "./box-content.types";

/**
 * Content for a box component. Mostly to add padding.
 * @param props.children          Box content.
 * @param props.className         Optional class name.
 * @param props.horizontalPadding Whether to apply horizontal padding or not.
 * @param props.verticalPadding   Whether to apply vertical padding or not.
 * @returns                       Box content container.
 */
const BoxContent: FunctionComponent<IProps> = ({
    children,
    className,
    horizontalPadding = true,
    verticalPadding = true,
}) => {
    return (
        <div
            className={classNames("box-content", className, {
                "box-content--horizontal-padding": horizontalPadding === true,
                "box-content--vertical-padding": verticalPadding === true,
            })}
        >
            {children}
        </div>
    );
};

export default memo(BoxContent);
